// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AssemblyRegistrationStatus } from '@/assembly/api/get-assemblies';
import { FilterOption } from '@/components/filter-toggle-group';

export const ASSEMBLY_STATUS_OPTIONS: FilterOption<AssemblyRegistrationStatus>[] =
  [
    { value: 'unregistered', label: 'Unregistered' },
    { value: 'registered', label: 'Registered' },
  ];
